'use strict';

var _interopRequireWildcard = require('@babel/runtime/helpers/interopRequireWildcard');

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

Object.defineProperty(exports, '__esModule', {
    value: true,
});
exports['default'] = void 0;

var _slicedToArray2 = _interopRequireDefault(require('@babel/runtime/helpers/slicedToArray'));

var _react = _interopRequireWildcard(require('react'));

var _reactComponents = require('../../../../react-components');

var _styles = _interopRequireDefault(require('./styles'));

var SelectContainer = _styles['default'].SelectContainer,
    Header = _styles['default'].Header,
    Title = _styles['default'].Title,
    LocationsContainer = _styles['default'].LocationsContainer,
    ButtonContainer = _styles['default'].ButtonContainer;

var LocationSelect = function LocationSelect(props) {
    var supplierDetails = props.supplierDetails,
        toggle = props.toggle,
        updateLocation = props.updateLocation,
        setNewLocation = props.setNewLocation,
        setToggle = props.setToggle,
        mobile = props.mobile;

    var _useState = (0, _react.useState)(supplierDetails.location),
        _useState2 = (0, _slicedToArray2['default'])(_useState, 2),
        curLocation = _useState2[0],
        setCurLocation = _useState2[1];

    return /*#__PURE__*/ _react['default'].createElement(
        SelectContainer,
        {
            mobile: mobile,
        },
        /*#__PURE__*/ _react['default'].createElement(
            Header,
            null,
            /*#__PURE__*/ _react['default'].createElement(
                'div',
                {
                    className: 'button-container',
                    onClick: function onClick() {
                        return setToggle(!toggle);
                    },
                },
                /*#__PURE__*/ _react['default'].createElement('i', {
                    className: 'far fa-arrow-left',
                }),
                /*#__PURE__*/ _react['default'].createElement('p', null, 'Back'),
            ),
        ),
        /*#__PURE__*/ _react['default'].createElement(
            Title,
            null,
            /*#__PURE__*/ _react['default'].createElement(
                'h2',
                null,
                ''.concat(supplierDetails.supplier.name, ' Locations'),
            ),
            /*#__PURE__*/ _react['default'].createElement(
                'label',
                {
                    className: 'lite italic',
                },
                'Select a store to see item availability at that location only.',
            ),
        ),
        /*#__PURE__*/ _react['default'].createElement(
            LocationsContainer,
            null,
            supplierDetails.locations.map(function(location, i) {
                return /*#__PURE__*/ _react['default'].createElement(
                    'div',
                    {
                        className: 'location-container',
                        key: i,
                        onClick: function onClick() {
                            return setCurLocation(location);
                        },
                    },
                    /*#__PURE__*/ _react['default'].createElement(
                        'div',
                        {
                            className: 'location',
                        },
                        /*#__PURE__*/ _react['default'].createElement('p', null, location.name),
                        /*#__PURE__*/ _react['default'].createElement(
                            'p',
                            {
                                className: 'address',
                            },
                            ''
                                .concat(location.street, ', ')
                                .concat(location.city, ', ')
                                .concat(location.state, ' ')
                                .concat(location.zip),
                        ),
                    ),
                    curLocation.storeCode === location.storeCode &&
                        /*#__PURE__*/ _react['default'].createElement('i', {
                            className: 'far fa-check',
                        }),
                );
            }),
        ),
        /*#__PURE__*/ _react['default'].createElement(
            ButtonContainer,
            {
                mobile: mobile,
            },
            /*#__PURE__*/ _react['default'].createElement(_reactComponents.Button, {
                type: 'action',
                title: 'Set Location',
                onClick: function onClick() {
                    return updateLocation({
                        setNewLocation: setNewLocation,
                        setToggle: setToggle,
                        toggle: toggle,
                        supplier: supplierDetails.supplier,
                        location: curLocation,
                    });
                },
            }),
        ),
    );
};

var _default = LocationSelect;
exports['default'] = _default;
